<template>
  <div v-if="surveillance">
    <h2>Observation des pratiques
      <span class="label" ref="title" :class="`label-${module}`">
        {{ moduleName }}
      </span>
    </h2>
    <hr>

    <div class="row" >
      <div class="col-lg-10">
        <alert type="warning" v-if="status === 0">
          <h3>Destinataire des écouvillons</h3>
          <p>
            Merci de remplir le formulaire ci-dessous afin que nous puissions
            envoyer vos écouvillons au plus vite.
          </p>
          <p>
            <strong class="text-danger">
              Une fois les écouvillons envoyés, l'inscription à RÉA Sink ne
              pourra plus être modifiée.
            </strong>
          </p>
          <hr>

          <div class="row">
            <div class="col-xs-12 col-md-6">
              <div class="form-group"
                   :class="{ 'has-error': firstName.error }">
                <label for="firstName" class="control-label">
                  Prénom du destinataire
                </label>
                <input required
                       id="firstName"
                       class="form-control"
                       :disabled="waiting"
                       v-model.trim="firstName.value"
                       type="text"
                       @blur="checkFirstName"
                       placeholder="Prénom"/>
                <span class="text-danger help-block">{{ firstName.error }}</span>
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <div class="form-group"
                   :class="{ 'has-error': name.error }">
                <label for="name" class="control-label">
                  Nom du destinataire
                </label>
                <input required
                       id="name"
                       class="form-control"
                       :disabled="waiting"
                       v-model.trim="name.value"
                       type="text"
                       @blur="checkName"
                       placeholder="Nom"/>
                <span class="text-danger help-block">{{ name.error }}</span>
              </div>
            </div>
          </div>
          <div class="form-group"
               :class="{ 'has-error': job.error }">
            <label for="job" class="control-label">
              Fonction du destinataire
            </label>
            <input required
                   id="job"
                   class="form-control"
                   :disabled="waiting"
                   v-model.trim="job.value"
                   type="text"
                   @blur="checkJob"
                   placeholder="PH, infirmière hygiéniste, ..."/>
            <span class="text-danger help-block">{{ job.error }}</span>
          </div>
          <div class="form-group"
               :class="{ 'has-error': establishment.error }">
            <label for="establishment" class="control-label">
              Nom de l'établissement
            </label>
            <input required
                   id="establishment"
                   class="form-control"
                   :disabled="waiting"
                   v-model.trim="establishment.value"
                   type="text"
                   @blur="checkEstablishment"
                   placeholder="Nom de l'établissement"/>
            <span class="text-danger help-block">{{ establishment.error }}</span>
          </div>
          <div class="form-group"
               :class="{ 'has-error': unit.error }">
            <label for="unit" class="control-label">
              Service
            </label>
            <input required
                   id="unit"
                   class="form-control"
                   :disabled="waiting"
                   v-model.trim="unit.value"
                   type="text"
                   @blur="checkUnit"
                   placeholder="Service"/>
            <span class="text-danger help-block">{{ unit.error }}</span>
          </div>
          <div class="form-group"
               :class="{ 'has-error': address.error }">
            <label for="address" class="control-label">
              Adresse précise
            </label>
            <input required
                   id="address"
                   class="form-control"
                   :disabled="waiting"
                   v-model.trim="address.value"
                   type="text"
                   @blur="checkAddress"
                   placeholder="Adresse"/>
            <span class="text-danger help-block">{{ address.error }}</span>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <div class="form-group"
                   :class="{ 'has-error': code.error }">
                <label for="code" class="control-label">
                  Code Postal
                </label>
                <cleave v-model.trim="code.value"
                        :options="code.options"
                        class="form-control"
                        :disabled="waiting"
                        autocomplete="off"
                        placeholder="Code postal"
                        @blur="checkCode"
                        name="code">
                </cleave>
                <span class="text-danger help-block">{{ code.error }}</span>
              </div>
            </div>

            <div class="col-xs-12 col-md-6">
              <div class="form-group"
                   :class="{ 'has-error': town.error }">
                <label for="town" class="control-label">
                  Ville
                </label>
                <input required
                       id="town"
                       class="form-control"
                       :disabled="waiting"
                       v-model.trim="town.value"
                       type="text"
                       @blur="checkTown"
                       placeholder="Ville"/>
                <span class="text-danger help-block">{{ town.error }}</span>
              </div>
            </div>
          </div>
          <hr>
          <div class="form-group"
               :class="{ 'has-error': beds.error }">
            <label for="beds" class="control-label">
              Nombre de lits dans le service
            </label>
            <cleave v-model.trim="beds.value"
                    :options="beds.options"
                    class="form-control"
                    :disabled="waiting"
                    autocomplete="off"
                    @blur="checkBeds"
                    placeholder="Nombre de lits dans le service"
                    name="beds">
            </cleave>
            <span class="text-danger help-block">{{ beds.error }}</span>
          </div>
          <div class="form-group"
               :class="{ 'has-error': waterPoints.error }">
            <label for="waterPoints" class="control-label">
              Nombre de points d'eau <small>(nombre d'écouvillons à envoyer)</small>
            </label>
            <cleave v-model.trim="waterPoints.value"
                    :options="waterPoints.options"
                    class="form-control"
                    :disabled="waiting"
                    autocomplete="off"
                    @blur="checkWaterPoints"
                    placeholder="Nombre de points d'eau"
                    name="waterPoints">
            </cleave>
            <span class="text-danger help-block">{{ waterPoints.error }}</span>
          </div>
          <hr>

          <collapse v-model="swabError.error">
            <p>
              <sui-error-panel :error="swabError" v-if="swabError.error">
              </sui-error-panel>
            </p>
          </collapse>
          <div class="text-center">
            <btn type="success" @click="send" size="lg"
                 :disabled="waiting || !validForm">
              Envoyer
            </btn>
          </div>
        </alert>
        <alert v-else-if="status === 1" type="info">
          <h3>En attente d'envoi des écouvillons</h3>
          <p>
            <strong>
              Les écouvillons sont en cours de préparation par notre équipe et
              seront envoyés au plus vite à l'adresse suivante :
            </strong>
          </p>
          <div class="panel panel-default">
            <div class="panel-body">
              <span v-for="(s, k) in swab" :key="`swab-line-${k}`">
                <strong>{{ s }}<br></strong>
              </span>
            </div>
          </div>
          <p>
            <strong>
              Si cette adresse vous semble erronée, merci de nous contacter au
              plus vite via le <router-link to="/contact">formulaire de contact
              </router-link>.
            </strong>
          </p>
        </alert>
        <alert v-else-if="status === 2" type="warning">
          <h3>Écouvillons envoyés</h3>
          <p>
            Les écouvillons ont été envoyés à l'adresse suivante :
          </p>
          <div class="panel panel-default">
            <div class="panel-body">
              <span v-for="(s, k) in swab" :key="`swab-line-${k}`">
                <strong>{{ s }}<br></strong>
              </span>
            </div>
          </div>
          <p>
            <btn type="success" @click="notifyReceived" :disabled="waiting">
              J'ai reçu les écouvillons
            </btn>
          </p>
        </alert>
        <alert v-else-if="status === 3" type="warning">
          <h3>Prélèvements</h3>
          <p>
            À vous désormais de réaliser l'écouvillonnage des
            siphons, en respectant les règles suivantes :
            <ul>
              <li>
                Remplir pour chaque chambre la fiche «points d'eau».
              </li>
              <li>
                Identifier les écouvillons avec le numéro de la
                chambre suivi du numéro du point d’eau, comme sur la fiche
                «points d’eau» associée. <br>
                <i>
                  Exemple: 245-1 pour la chambre 245 et le point d'eau numéro 1.
                </i>
              </li>
              <li class="text-danger">
                <strong>ATTENTION !</strong><br>
                Les prélèvements doivent être impérativement
                réalisés <strong>au moins 24h après la dernière désinfection
                des points d'eau</strong> et avant l’entretien quotidien du
                lavabo. <strong>Sinon, REPORTER les prélèvements</strong>.
              </li>
            </ul>
            Pour plus d'informations, merci de consulter le guide technique du
            module RÉA Sink.
          </p>
          <h3>Envoi des écouvillons</h3>
          <p>
            Une fois les prélèvements effectués, merci de transmettre
            <strong>sans délai</strong> les écouvillons accompagnés des fiches
            «points d'eau» à l'adresse suivante :
          </p>
          <div class="panel panel-default">
            <div class="panel-body">
              <strong>
                Mme Sandra DOS SANTOS<br>
                CRENO<br>
                Laboratoire de Bactériologie et Hygiène du CHU Trousseau<br>
                37044 Tours Cedex 9
              </strong>
            </div>
          </div>
          <p class="text-danger">
            <strong>ATTENTION !</strong><br>
            Les écouvillons doivent être conservés (si nécessaire) et envoyés
            à température ambiante.<br>
            <strong>
              Ne pas mettre les écouvillons au réfrigérateur ni au congélateur.
            </strong>
          </p>
          <hr>
          <p>
            <btn type="success" @click="notifyReturned" :disabled="waiting">
              J'ai renvoyé les écouvillons et les fiches points d'eau
            </btn>
          </p>
        </alert>
        <alert v-else-if="status === 4" type="info">
          <h3>Écouvillons renvoyés à la SPIADI</h3>
          <p>
            Cette page sera mise à jour dès que les écouvillons auront été
            réceptionnés au laboratoire.
          </p>
          <p>
            Merci pour votre participation à l'enquête
            <span class="label label-reaSink">RÉA Sink</span> !
          </p>
        </alert>
        <alert v-else-if="status === 5" type="info">
          <h3>Écouvillons au laboratoire</h3>
          <p>
            Les écouvillons ont bien été reçus et sont en cours d'analyse.
          </p>
        </alert>
        <alert v-else type="success">
          <h3>Enquête terminée</h3>
          <p>
            <strong>
              Merci pour votre participation à l'enquête
              <span class="label label-reaSink">RÉA Sink</span> !
            </strong>
          </p>
          <p class="text-justify">
            Vos résultats vous seront très prochainement envoyés par e-mail.
          </p>
        </alert>
      </div>
    </div>
  </div>
</template>
<script>
import modules from '@/sui/data/modules'
import cleave from 'vue-cleave-component'
import suiErrorPanel from '@/sui/components/errorpanel'
import Error from '@/sui/tools/error'
import { confirm } from '@/sui/tools/modal'

export default {
  name: 'rea-sink-dashboard',

  props: {
    surveillance: {
      type: Object
    },

    year: {
      type: String,
      required: true
    },

    module: {
      type: String,
      required: true
    }
  },

  data: function () {
    const fields = [
      'firstName', 'name', 'job', 'establishment', 'unit', 'address',
      'code', 'town', 'beds', 'waterPoints'
    ]
    const result = {
      waiting: false,
      swabError: new Error(),
      fields: fields
    }
    fields.forEach(f => { result[f] = { value: '', error: '' } })
    result.code.options = {
      numericOnly: true,
      blocks: [5],
      numeralThousandsGroupStyle: 'none'
    }
    result.beds.options = {
      numeral: true,
      numeralIntegerScale: 2,
      numeralThousandsGroupStyle: 'none'
    }
    result.waterPoints.options = {
      numeral: true,
      numeralIntegerScale: 2,
      numeralThousandsGroupStyle: 'none'
    }
    return result
  },

  computed: {
    moduleName: function () {
      return modules[this.year][this.module].label
    },

    moduleData: function () {
      return this.surveillance.modules[this.module]
    },

    swab: function () {
      const { dest } = this.moduleData.swab
      return [
        dest.establishment,
        `${dest.firstName} ${dest.name}`,
        dest.role,
        dest.service,
        dest.address
      ]
    },

    status: function () {
      return this.moduleData.status.val
    },

    validForm: function () {
      const { fields } = this
      for (let i = 0; i !== fields.length; ++i) {
        const f = this[fields[i]]
        if (f.value === '' || f.error !== '') {
          return false
        }
      }
      return true
    }
  },

  methods: {
    confirm: function (action, status) {
      confirm(
        this,
        `<h3>Changement de statut
<span class='label-bigger label label-reaSink'>RÉA Sink</span></h3>
<p class="text-justify">
Êtes vous sûr.e de vouloir changer le statut de l'établissement
<strong>${this.surveillance.establishment.name}</strong> en
<strong>«${action}»</strong> ?</p>`
      ).then(() => {
        this.setStatus(status)
      })
    },

    setStatus: function (status) {
      const request = {
        id: this.surveillance.id,
        stat: status
      }
      const vm = this
      vm.waiting = true
      this.$store.dispatch('surveillances/updateReaSinkStatus', request).then(
        r => {
          vm.waiting = false
          if (r.data.err != null) {
            vm.$notify(
              {
                type: 'danger',
                title: 'Erreur !',
                duration: 0,
                content: `Une erreur s'est produite pendant la mise à jour du
statut RÉA Sink. Si le problème persiste, merci de nous contacter via le
 formulaire de contact.`
              }
            )
          } else {
            vm.$notify(
              {
                type: 'success',
                title: 'Succès !',
                content: `Le changement de statut RÉA Sink a bien été effectué.`
              }
            )
          }
        }
      ).catch(
        e => {
          vm.waiting = false
          vm.$notify(
            {
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une exception s'est produite pendant la mise à jour du
statut RÉA Sink. Si le problème persiste, merci de nous contacter via le
 formulaire de contact.`
            }
          )
        }
      )
    },

    notifyReceived: function () {
      this.confirm(`écouvillons reçus`, 3)
    },

    notifyReturned: function () {
      this.confirm(`écouvillons renvoyés`, 4)
    },

    send: function () {
      if (!this.validForm) {
        return
      }
      this.swabError.reset()
      const address =
        `${this.address.value} ${this.code.value} ${this.town.value}`
      const request = {
        id: this.surveillance.id,
        swab: {
          destination: {
            firstName: this.firstName.value,
            name: this.name.value,
            role: this.job.value,
            service: this.unit.value,
            establishment: this.establishment.value,
            address: address
          },
          bedsNb: parseInt(this.beds.value),
          waterPointsNb: parseInt(this.waterPoints.value)
        }
      }
      this.waiting = true
      const vm = this
      this.$store.dispatch('surveillances/setSwab', request).then(
        r => {
          if (r.data.err != null) {
            vm.setSwabError()
          } else {
            this.$notify(
              {
                type: 'success',
                title: `${vm.firstName.value} ${vm.name.value} a bien été
ajouté.e en tant que destinataire des écouvillons !`,
                duration: 10000,
                content: `Les écouvillons seront expédiés au plus tôt par notre
équipe.`
              }
            )
          }
          return r
        }
      ).catch(
        e => {
          vm.setSwabError()
        }
      )
    },

    setSwabError: function () {
      this.waiting = false
      this.swabError.set(
        'Erreur interne !',
        `Une erreur s'est produite lors de l'envoi du formulaire.`,
        `Merci de vérifier votre connexion internet avant de réessayer.`,
        true
      )
    },

    checkEmpty: function (field, text) {
      if (field.value === '') {
        field.error = text
      } else {
        field.error = ''
      }
    },

    checkFirstName: function () {
      this.checkEmpty(this.firstName, 'Aucun prénom saisi.')
    },

    checkName: function () {
      this.checkEmpty(this.name, 'Aucun nom saisi.')
    },

    checkJob: function () {
      this.checkEmpty(this.job, 'Aucune fonction saisie.')
    },

    checkEstablishment: function () {
      this.checkEmpty(
        this.establishment, `Aucun nom d'établissement saisi.`
      )
    },

    checkUnit: function () {
      this.checkEmpty(this.unit, 'Aucun service saisi.')
    },

    checkAddress: function () {
      this.checkEmpty(this.address, 'Aucune adresse saisie.')
    },

    checkCode: function () {
      const { code } = this
      if (code.value === '') {
        code.error = 'Aucun code postal saisi.'
      } else if (code.value.length !== 5) {
        code.error = 'Code postal invalide.'
      } else {
        code.error = ''
      }
    },

    checkBeds: function () {
      const { beds } = this
      if (beds.value === '') {
        beds.error = 'Aucun nombre de lits saisi.'
        return
      }

      const nb = parseInt(beds.value)
      if (nb <= 0) {
        beds.error = 'Le service doit comporter au moins un lit.'
        return
      }
      if (nb >= 30) {
        beds.error = 'Le service doit comporter au maximum trente lits.'
        return
      }
      beds.error = ''
    },

    checkWaterPoints: function () {
      const { beds, waterPoints } = this
      if (waterPoints.value === '') {
        waterPoints.error = 'Aucun nombre de lits saisi.'
        return
      }

      const nb = parseInt(waterPoints.value)
      if (nb <= 0) {
        waterPoints.error = `Le service doit comporter au moins un point d'eau.`
        return
      }

      if (beds.value !== '' && beds.error === '') {
        const nbeds = parseInt(beds.value)
        if (nb > nbeds * 2) {
          waterPoints.error =
            `Le service ne doit pas comporter plus de deux points d'eau par lit.`
          return
        }

        if (nb * 2 < nbeds) {
          waterPoints.error =
            `Le service ne doit pas comporter moins d'un point d'eau pour deux lits.`
          return
        }
      }

      waterPoints.error = ''
    },

    checkTown: function () {
      this.checkEmpty(this.town, 'Aucune ville saisie.')
    }
  },

  components: {
    'cleave': cleave,
    'sui-error-panel': suiErrorPanel
  }
}
</script>
<style scoped lang="less">
@import '~variables';

.has-error .control-label {
  color: @brand-danger;
}

.has-error .help-block {
  color: @brand-danger;
}

.panel {
  font-size: 110%;
  text-align: center;
  margin: 2rem;
}

.alert > h3:first-child {
  margin-top: 0rem;
}

.alert-success h3 {
  color: white;
}
</style>
